import React from 'react'
import ExpenseCategoryLabels from 'src/app/ExpenseCategoryLabels/ExpenseCategoryLabels'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { expenseCategoryLabelsRouteProps } from 'src/navigation/routeProps'

const ExpenseCategoryLabelsAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsExpenseCategoryLabels,
  routeProps: expenseCategoryLabelsRouteProps,
  component: <ExpenseCategoryLabels />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default ExpenseCategoryLabelsAppRoute
